import { render } from "./ClearDelegate.vue?vue&type=template&id=15f6dfe8"
import script from "./ClearDelegate.vue?vue&type=script&lang=js"
export * from "./ClearDelegate.vue?vue&type=script&lang=js"
script.render = render

export default script